import { Userpilot } from 'userpilot';
import { AccountDefinition, Features, ModuleNames } from '../../../common/model/account-definition';

export class UserpilotService {
  private static _initialized = false;

  public static initialize(appToken: string): void {
    if (UserpilotService._initialized) return;

    // The package injects the hosted SDK and queues calls until that script has loaded.
    Userpilot.initialize(appToken);
    UserpilotService._initialized = true;
  }

  public static identifyUser(userContext: AccountDefinition): void {
    if (!UserpilotService._initialized) return;

    Userpilot.identify(userContext.id, {
      is_internal: UserpilotService.isInternalEmail(userContext.email),
      can_manage_users: userContext.hasAccess(ModuleNames.System, Features.Admin),
      can_manage_billing: userContext.hasAccess(ModuleNames.Invoicing, Features.ManageInvoices),
      can_see_customer_account: userContext.hasAccess(ModuleNames.System, Features.Overview),
      has_any_permission: userContext.modules.length > 0 || userContext.features.length > 0,
      language: UserpilotService.currentLanguage(),
      company: {
        id: userContext.systemOwnerId,
        name: userContext.name
      }
    });
  }

  // A client-side route change is invisible to Userpilot until reload is called.
  public static reload(): void {
    if (!UserpilotService._initialized) return;

    Userpilot.reload();
  }

  public static track(eventName: string, properties?: Record<string, unknown>): void {
    if (!UserpilotService._initialized) return;

    Userpilot.track(eventName, properties);
  }

  public static resetUser(): void {
    if (!UserpilotService._initialized) return;

    Userpilot.clean();
    Userpilot.anonymous();
  }

  private static isInternalEmail(email: string): boolean {
    const domain = email?.toLowerCase().split('@')[1];
    return !!domain && domain.includes('hogia');
  }

  private static currentLanguage(): string {
    return localStorage.getItem('lang') ?? 'sv';
  }
}
